import React, { useState } from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { Add as AddIcon, CloudDownload as MuiCloudDownload } from '@material-ui/icons'

import {
  useQueryPaginator,
  LinkedField,
  PaginatedTable,
  NumberField,
  ValueField,
  BooleanField,
} from 'src/components/Table'
import { ExportDialog } from 'src/components/Dialog'

import { skuit } from 'src/services/skuit'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const CloudDownload = styled(MuiCloudDownload)(spacing)
const Divider = styled(MuiDivider)(spacing)
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const SkuListPage = () => {
  const paginator = useQueryPaginator('sku-list', skuit.client.skus.list)
  const [exportOpen, setExportOpen] = useState(false)

  return (
    <>
      <Helmet title="SKUs" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            SKUs
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>SKUs</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <div>
            <Button variant="contained" color="primary" onClick={() => alert('Coming soon!')}>
              <AddIcon />
              New SKU
            </Button>
          </div>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export Inventory to CSV
          </Button>
        </Grid>
        <Grid item xs={12}>
          <PaginatedTable
            title="SKUs"
            fields={[
              { id: 'sku', label: 'SKU', renderer: LinkedField(ValueField) },
              {
                id: 'productName',
                label: 'Product',
                ordering: 'product_name',
                renderer: ValueField,
              },
              {
                id: 'numAvailable',
                label: 'Number of Available Units',
                ordering: 'num_available',
                renderer: NumberField,
              },
              {
                id: 'numReserved',
                label: 'Number of Units in Orders',
                ordering: 'num_reserved',
                renderer: NumberField,
              },
              {
                id: 'numAwaitingShipment',
                label: 'Number of Units Awaiting Shipment',
                ordering: 'num_awaiting_shipment',
                renderer: NumberField,
              },
              { id: 'isActive', label: 'Is Active', renderer: BooleanField },
            ]}
            paginator={paginator}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export Inventory to CSV
          </Button>
        </Grid>
      </Grid>
      <ExportDialog
        name="SKUs"
        download={skuit.client.skus.export}
        open={exportOpen}
        fields={['sku', 'product', 'num_available', 'num_reserved', 'num_awaiting_shipment']}
        handleClose={() => setExportOpen(false)}
      />
    </>
  )
}
